module.exports = "<div class=\"flip-container card-wrapper\" [ngClass]=\"{'rotate': rotate}\">\r\n  <div class=\"flipper card-rotating effect__click tp-box\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/cards/card-rotating.component.html
// module id = ../../../../../src/libs/mdbootstrap/typescripts/pro/cards/card-rotating.component.html
// module chunks = main